import { chakra, Td as ChakraTd, Th as ChakraTh, Tr as ChakraTr } from '@chakra-ui/react';

const tableBorder = '1px solid var(--chakra-colors-gray-200)';

export const Th = chakra(ChakraTh, {
  baseStyle: {
    padding: '0.85rem 1.5rem',
    cursor: 'pointer',
    textAlign: 'start',
    borderBottom: tableBorder,
    borderEnd: tableBorder,
    bgColor: 'white',
    color: 'gray.300',

    _first: {
      borderRadius: '6px 0 0 0',
      paddingStart: '2.5rem',
    },
    _last: {
      borderRadius: '0 6px 0 0',
      paddingEnd: '2.5rem',
      borderEnd: 'none',
    },
  },
});

export const Tr = chakra(ChakraTr, {
  baseStyle: {
    borderBottom: 'none',
    _last: {
      'td:first-of-type': {
        borderBottomStartRadius: '6px',
      },
      'td:last-of-type': {
        borderBottomEndRadius: '6px',
      },
    },
    '&:nth-child(even) td': {
      bgColor: 'gray.50',
    },
  },
});

export const Td = chakra(ChakraTd, {
  baseStyle: {
    padding: '1.25rem 1.5rem',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    lineHeight: '1.4em',
    fontSize: 'md',
    borderEnd: tableBorder,
    borderBottom: 'none',
    bgColor: 'white',

    _first: {
      paddingStart: '2.5rem',
    },
    _last: {
      paddingEnd: '2.5rem',
      borderEnd: 'none',
    },
  },
});
